export var ADULTS_KEY = 'adults';
export var CHILDREN_KEY = 'children';
export var ADULTS_NUMBER_KEY = 'adultsNumber';
export var CHILDREN_NUMBER_KEY = 'childrenNumber';
export var ROOM_TYPE_KEY = 'roomType';
export var SHOULD_INCLUDE_COT = 'shouldIncludeCot';
export var SHOULD_BE_ACCESSIBLE = 'shouldBeAccessible';